import { CommonModule, NgIf, NgStyle } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { GeneralDialogOkComponent } from 'src/app/core/dialog/general-dialog-ok/general-dialog-ok.component';
import { AuthService } from 'src/app/core/services/auth-security/auth.service';
import { DataService } from 'src/app/core/services/data/data.service';
import { ParkerStateService } from 'src/app/core/services/state/parker-state.service';
import {
  IApnMassActivationSpaceEmailLink,
  IApnSpaceEmailLink,
  ILotList,
  IParkerActivationReturnData,
  IParkersReadyForactivation,
} from 'src/app/shared/interfaces';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-parker-v2-accounts-to-activate',
  templateUrl: './parker-v2-accounts-to-activate.component.html',
  styleUrl: './parker-v2-accounts-to-activate.component.scss',
  standalone: true,
  imports: [MatProgressSpinnerModule, NgStyle, NgIf, CommonModule],
})
export class ParkerV2AccountsToActivateComponent implements OnInit {
  isUserAdmin: boolean = false;
  userName: string = '';
  LotListByUserName: ILotList[] = [];
  lotNumber: string = '';
  parkerActivationList: IParkersReadyForactivation[] = [];
  selectedLot: string = '';
  gridFontSize: number = 12;
  numberOfParkersSelected: number = 0;
  allParkersChecked: boolean = false;
  newSpaceEmailLinkData: IApnMassActivationSpaceEmailLink[] = [];
  parkerActivationReturnData: IParkerActivationReturnData[] = [];
  isProcessingNewUsers: boolean = false;
  lotDisplayName: string = '';
  urlDomain: string = '';
  queryPerformed: boolean = false;

  //Services
  _appGeneralState = inject(AppGeneralStateService);

  constructor(
    private authService: AuthService,
    private dataService: DataService,
    private _parkerState: ParkerStateService,
    private routerService: Router,
    private _matDialog: MatDialog,
  ) {
    this.userName = this._appGeneralState.userName;
    this.urlDomain = environment.UrlDomain;
    if (this.userName == '') {
      this.routerService.navigate([`/badroute`]);
    }
  }

  ngOnInit(): void {
    this.lotNumber = this._appGeneralState.currentLotNumber;
    this.lotDisplayName = this._appGeneralState.currentLotNumber + ' - ' + this._appGeneralState.currentLotName;
    //  this.getSpaceIdByEmailAddress(this.userName);
  }

  onNavToParkersHome(): void {
    this.routerService.navigate([`/parkerlist`]);
  }

  isParkerFlaggedForActivation(rowIndex: number): boolean {
    return this.parkerActivationList[rowIndex].activateFlag === true;
  }

  onCheckParker(parkerId: string): void {
    let ii: number;
    let isFlagged: boolean = false;

    for (ii = 0; ii < this.parkerActivationList.length; ii++) {
      if (this.parkerActivationList[ii].parkerId === parkerId) {
        this.parkerActivationList[ii].activateFlag = !this.parkerActivationList[ii].activateFlag;
      }
    }

    this.setNumberOfParkersSelected();
  }

  onActivateParkers(): void {
    let ii: number = 0;

    for (ii = 0; ii < this.parkerActivationList.length; ii++) {
      let aNewSpaceUser: IApnMassActivationSpaceEmailLink = {} as IApnMassActivationSpaceEmailLink;
      if (this.parkerActivationList[ii].activateFlag) {
        aNewSpaceUser.emailAddress = this.parkerActivationList[ii].emailAddress;
        aNewSpaceUser.parkerId = this.parkerActivationList[ii].parkerId;
        aNewSpaceUser.lotNumber = this.parkerActivationList[ii].lotNumber;
        aNewSpaceUser.spaceUserId = 0;
        aNewSpaceUser.lastModifiedByUserId = this._appGeneralState.userName;
        aNewSpaceUser.dateLastModified = new Date().toLocaleString();

        this.newSpaceEmailLinkData.push(aNewSpaceUser);
      }
    }

    this.postNewSpaceEmail(this.newSpaceEmailLinkData);
  }

  onToggleCheckAll(): void {
    this.allParkersChecked = !this.allParkersChecked;
    let ii: number;

    for (ii = 0; ii < this.parkerActivationList.length; ii++) {
      this.parkerActivationList[ii].activateFlag = this.allParkersChecked;
    }

    if (this.allParkersChecked) {
      this.numberOfParkersSelected = this.parkerActivationList.length;
    } else this.numberOfParkersSelected = 0;
  }

  setNumberOfParkersSelected(): void {
    let ii: number = 0;

    this.numberOfParkersSelected = 0;

    for (ii = 0; ii < this.parkerActivationList.length; ii++) {
      if (this.parkerActivationList[ii].activateFlag === true) this.numberOfParkersSelected++;
    }
  }

  DisplayNoParkersFounddDialog(): void {
    const dlgTitle: string = 'No Parkes Found.';
    const dlgLine1: string = 'Lot ' + this.lotDisplayName;
    const dlgLine2: string = '';
    let enterAnimationDuration: string = '0ms';
    let exitAnimationDuration: string = '0ms';

    const dialogRef = this._matDialog.open(GeneralDialogOkComponent, {
      data: { dlgTitle: dlgTitle, dlgLine1: dlgLine1, dlgLine2: dlgLine2 },
      width: '450px',
      enterAnimationDuration,
      exitAnimationDuration,
    });
  }

  onSubmitParkersReadyForActivation(): void {
    this.queryPerformed = true;
    this.allParkersChecked = false;
    this.getParkersReadyForActivationList(this.lotNumber);
  }

  processNewUsersAfterAdding(): void {
    let ii: number;
    let jj;
    this.numberOfParkersSelected;

    for (ii = 0; ii < this.parkerActivationReturnData.length; ii++) {
      for (jj = 0; jj < this.parkerActivationList.length; jj++) {
        if (this.parkerActivationReturnData[ii].parkerId === this.parkerActivationList[jj].parkerId) {
          if (this.parkerActivationReturnData[ii].status === true) this.parkerActivationList[jj].result = 1;
          else this.parkerActivationList[jj].result = 2;
        }
      }
    }
  }

  postNewSpaceEmail(newSpaceEmailData: IApnMassActivationSpaceEmailLink[]) {
    let newSpaceEmailId: number;
    this.isProcessingNewUsers = true;
    this.dataService.postParkerActivateSpaceAccount(newSpaceEmailData).subscribe(
      (res) => {
        this.parkerActivationReturnData = res;
        this.isProcessingNewUsers = false;
      },
      (err: any) => {
        this.isProcessingNewUsers = false;
        this.newSpaceEmailLinkData = [];
      },
      () => {
        let ii: number;
        this.newSpaceEmailLinkData = [];
        this.processNewUsersAfterAdding();
      },
    );
  }

  getParkersReadyForActivationList(lotNumber: string) {
    this.dataService.getParkersReadyForActivationByLotNumber(lotNumber).subscribe(
      (parkerList) => {
        this.parkerActivationList = parkerList;
      },
      (err: any) => {},
      () => {
        let ii: number = 0;
        for (ii = 0; ii < this.parkerActivationList.length; ii++) {
          this.parkerActivationList[ii].result = 0; //0 = not submitted;
        }

        if (this.parkerActivationList.length == 0) this.DisplayNoParkersFounddDialog();
      },
    );
  }

  getLotListsNotRestrictedForSpaceActivation() {
    this.dataService.GetAdminMassActivationLotList().subscribe(
      (LotListByUserName) => {
        this.LotListByUserName = LotListByUserName;
      },
      (err: any) => {},
      () => {},
    );
  }

  getSpaceIdByEmailAddress(userName: string): void {
    let spaceUserid: number;

    this.dataService.getIsUserAdmin(userName).subscribe(
      (res) => {
        this.isUserAdmin = res;
      },
      (err: any) => {},
      () => {
        if (!this.isUserAdmin) {
          this.routerService.navigate([`/badroute`]);
        }

        let userName: string = this._appGeneralState.userName;
        if (userName === 'kmoss' || userName === 'lgonzalez' || userName === 'jizigzon') {
        } else this.routerService.navigate([`/badroute`]);
      },
    );
  }
}
